/*
*Author: Sohom
*Description: class to handale RTC connection related functionality
*              Like Brwoser compatibilty and borrowing it's appropriate stack,
*              calling getUserMedia feature,screen share extension conifiguration etc.
*Version: V 1.0
 */
/*
global import RTC stack Refewrence by including file from ./webrtc-stacks/* */
import ChromeStableStack from './webrtc-stacks/ChromeStableStack';
import FirefoxStack from './webrtc-stacks/FirefoxStack';
import FcStack from './webrtc-stacks/FcStack';
import Logger from './utils/Logger';
import GUMErrorHandler from './utils/ErrorHandler';
import customErrors from './customErrors';
import VcxEvent from './vcxEventProperties';
import customEvents from './customEvents';
import EL from './EventLogger';


let VcxRtcSessionId = 103;
let getUserMediaDelayed;
let gotMediaPermission = false;
const that = {};
that.deviceList = undefined;
const browserEngineCheck = () => {
    let browser = 'none';

    if ((typeof module !== 'undefined' && module.exports)) {
        browser = 'fake';
    } else if (window.navigator.userAgent.match('Firefox') !== null) {
        // Firefox
        browser = 'mozilla';
    } else if (window.navigator.userAgent.match('Chrome') !== null) {
        browser = 'chrome-stable';
        if (window.navigator.userAgent.match('Electron') !== null) {
            browser = 'electron';
        } else if (window.navigator.userAgent.match('Edge') !== null) {
            browser = 'edge';
        }
    } else if (window.navigator.userAgent.match('Safari') !== null) {
        browser = 'safari';
    } else if (window.navigator.userAgent.match('AppleWebKit') !== null) {
        browser = 'safari';
    } else if (window.navigator.userAgent.match('.NET') !== null) {
        browser = 'IE';
    }
    return browser;
};


const getBrowserVersion = () => {
    const { userAgent } = navigator;
    let temp;
    let Match = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(Match[1])) {
        temp = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return `IE ${temp[1] || ''}`;
    }
    if (Match[1] === 'Chrome') {
        temp = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
        if (temp != null) return temp.slice(1).join(' ').replace('OPR', 'Opera');
    }

    Match = Match[2] ? Match[2] : navigator.appVersion;
    if ((temp = userAgent.match(/version\/([^\s]+)/i)) != null) Match = temp[1];
    return Match;
};
const isCurrentVerLess = (verToCheck) => {
    const currVer = getBrowserVersion();
    if (typeof verToCheck !== 'string') return false;
    const v1 = currVer.split('.');
    const v2 = verToCheck.split('.');
    const k = Math.min(v1.length, v2.length);
    for (let i = 0; i < k; ++i) {
        v1[i] = parseInt(v1[i], 10);
        v2[i] = parseInt(v2[i], 10);
        if (v1[i] > v2[i]) return false;
        if (v1[i] < v2[i]) return true;
    }
    return v1.length == v2.length ? false : (!(v1.length < v2.length));
};
const processDevice = (deviceList) => {
    const devices = { cam: [], mic: [], speaker: [] };
    for (let count = 0; count < deviceList.length; count++) {
        switch (deviceList[count].kind) {
            case 'audioinput':
                devices.mic.push(deviceList[count]);
                break;
            case 'videoinput':
                devices.cam.push(deviceList[count]);
                break;
            case 'audiooutput':
                devices.speaker.push(deviceList[count]);
                break;
            default:
                break;
        }
    }
    return devices;
};

const checkNewDevice = (dvcList) => {
    if (that.deviceList === undefined) {
        return undefined;
    }
    const devices = { cam: [], mic: [], speaker: [] };
    for (const camC in dvcList.cam) {
        var chkFlag = false;
        for (const camS in that.deviceList.cam) {
            if (dvcList.cam[camC].deviceId === that.deviceList.cam[camS].deviceId) {
                chkFlag = true;
            }
        }
        if (chkFlag === false) {
            devices.cam.push(dvcList.cam[camC]);
        }
    }
    for (const micC in dvcList.mic) {
        var chkFlag = false;
        for (const micS in that.deviceList.mic) {
            if (dvcList.mic[micC].deviceId === that.deviceList.mic[micS].deviceId) {
                chkFlag = true;
            }
        }
        if (chkFlag === false) {
            devices.mic.push(dvcList.mic[micC]);
        }
    }
    for (const speakerC in dvcList.speaker) {
        var chkFlag = false;
        for (const speakerS in that.deviceList.speaker) {
            if (dvcList.speaker[speakerC].deviceId === that.deviceList.speaker[speakerS].deviceId) {
                chkFlag = true;
            }
        }
        if (chkFlag === false) {
            devices.speaker.push(dvcList.speaker[speakerC]);
        }
    }
    if (devices.cam.length === 0 && devices.mic.length === 0 && devices.speaker.length === 0) {
        return undefined;
    }
    that.deviceList = dvcList;
    return devices;
};

const mediaDeviceUpdate = (callback) => {
    if (browserEngineCheck() === 'safari') {
        setInterval(() => {
            getDeviceList((dvL) => {
                if (that.deviceList === undefined) {
                    that.deviceList = dvL;
                } else {
                    const newDvList = checkNewDevice(dvL);
                    if (newDvList !== undefined) {
                        callback(newDvList);
                    }
                }
            });
        }, 3000);
    } else {
        navigator.mediaDevices.ondevicechange = function (event) {
            getDeviceList((dvL) => {
                if (that.deviceList === undefined) {
                    that.deviceList = dvL;
                } else {
                    const newDvList = checkNewDevice(dvL);
                    if (newDvList !== undefined) {
                        callback(newDvList);
                    }
                }
            });
        };
    }
};
const getMediaPermission = (config, callback) => {
    if (browserEngineCheck() === 'IE' || browserEngineCheck() === 'edge') {
        EL.error('agent-event', customEvents.event_incompatible_browser, { error: customErrors.error_1153 });
        callback(null, customErrors.error_1153);
        return;
    }
    //calling getUserMedia() causes blank on IOS safari self video when setting tab is called
    if (gotMediaPermission && browserEngineCheck() === 'safari') {
        callback('success', null);
        return;
    }
    //navigator.mediaDevices.getUserMedia({ audio: true, video: true })
    navigator.mediaDevices.getUserMedia(config)
        .then((stream) => {
            gotMediaPermission = true;
            callback(stream, null);
        }).catch((err) => {
            err = GUMErrorHandler(err);
            EL.error('agent-event', customEvents.event_gum_failed, { error: err });
            if ((err.result === customErrors.error_1143.result || err.result === customErrors.error_1144.result) &&
                config.video && config.audio) {
                //since cam not available or  permission denied , try audio
                console.log(`getUserMedia() failed with error: ${JSON.stringify(err)} retry with audio only`);
                getMediaPermission({ audio: true }, callback);
            } else {
                Logger.error(`Failed to get media devices permission: ${JSON.stringify(err)}`);
                callback(null, err);
            }
        });
};
const getList = (callback) => {
    navigator.mediaDevices.enumerateDevices()
        .then((dv) => {
            callback(dv);
        })
        .catch((err) => {
            err = GUMErrorHandler(err);
            callback(null, err);
            Logger.error(`Cannot get device list:  ${JSON.stringify(err)}`);
            EL.error('agent-event', customEvents.event_gum_failed, { error: err });
        });
};
const getDeviceList = (callback, mediaDeviceType) => {
    if (mediaDeviceType == undefined || mediaDeviceType != 'speaker') {
        getMediaPermission({ audio: true, video: true }, (stream, error) => {
            if (stream || (error && (error.result === customErrors.error_1145.result))) {
                getList((deviceList, errorList) => {
                    if (deviceList) {
                        const dvc = processDevice(deviceList);
                        callback({ result: 0, devices: dvc });
                    } else {
                        callback(((error && (error.result === customErrors.error_1145.result)) ? error : errorList));
                    }
                });
            } else {
                callback(error);
            }
        });
    } else {
        getList((deviceList, errorList) => {
            if (deviceList) {
                const dvc = processDevice(deviceList);
                callback({ result: 0, devices: dvc });
            }
        });
    }
};
const buildPair = (specInput) => {
    let that = {};
    const spec = specInput;
    VcxRtcSessionId += 1;
    spec.sessionId = VcxRtcSessionId;

    // Check which WebRTC Stack is installed.
    that.browser = browserEngineCheck();
    if (that.browser === 'fake') {
        Logger.warning('Publish/subscribe video/audio streams not supported in media yet');
        EL.warn('agent-event', customEvents.event_incompatible_browser, { error: 'Publish/subscribe video/audio streams not supported in media yet' });
        that = FcStack(spec);
    } else if (that.browser === 'mozilla') {
        Logger.debug('Firefox Stack');
        that = FirefoxStack(spec);
    } else if (that.browser === 'safari') {
        Logger.debug('Safari using Chrome Stable Stack');
        that = ChromeStableStack(spec);
    } else if (that.browser === 'chrome-stable' || that.browser === 'electron') {
        Logger.debug('Chrome Stable Stack');
        that = ChromeStableStack(spec);
    } else if (that.browser === 'IE') {
        Logger.debug('IE using Chrome Stable Stack');
        that = ChromeStableStack(spec);
    } else {
        Logger.error('No stack available for this browser');
        EL.error('agent-event', customEvents.event_incompatible_browser, { error: 'No stack available for this browser' });
        throw new Error('WebRTC stack not available');
    }
    if (!that.updateSpec) {
        that.updateSpec = (newSpec, callback = () => { }) => {
            Logger.error('Update Configuration not implemented in this browser');
            EL.error('agent-event', customEvents.event_incompatible_browser, { error: 'Update Configuration not implemented in this browser' });
            callback('unimplemented');
        };
    }

    return that;
};
const getPlugin = () => document.getElementById('WebrtcEverywherePluginId');
const attachEventListener = function (video, type, listener, useCapture) {
    video.addEventListener(type, listener, useCapture);
};
const GetUserMedia = (config, callback = () => { }, error = () => { }) => {
    let screenConfig;
    let getUserMedia;
    let getDisplayMedia;
    const browser = browserEngineCheck();
    if (browser === 'chrome-stable' || browser === 'electron' || browser === 'mozilla' || browser === 'safari') {
        getUserMedia = (userMediaConfig, cb, errorCb) => {
            navigator.mediaDevices.getUserMedia(userMediaConfig).then(cb).catch(errorCb);
        };
        getDisplayMedia = (userMediaConfig, cb, errorCb) => {
            if (navigator.getDisplayMedia) {
                navigator.getDisplayMedia({ video: true }).then(cb).catch(errorCb);
            } else {
                navigator.mediaDevices.getDisplayMedia(userMediaConfig).then(cb).catch(errorCb);
            }
        };
    } else {
        getUserMedia = navigator.getUserMedia = (userMediaConfig, cb, errorCb) => {
            if (document.readyState !== 'complete') {
                if (!getUserMediaDelayed) {
                    getUserMediaDelayed = true;
                    attachEventListener(document, 'readystatechange', () => {
                        if (getUserMediaDelayed && document.readyState == 'complete') {
                            getUserMediaDelayed = false;
                            getPlugin().getUserMedia(userMediaConfig, cb, errorCb);
                        }
                    });
                }
            } else {
                getPlugin().getUserMedia(userMediaConfig, cb, errorCb);
            }
        };
    }

    /*Author:Sohom
    *Description: configure screen sharing method/extension
    * */
    const configureScreensharing = () => {
        Logger.debug('Screen access requested');
        switch (browserEngineCheck()) {
            case 'electron':
                Logger.debug('Screen sharing in Electron');
                screenConfig = {};
                screenConfig.video = config.video || {};
                screenConfig.video.mandatory = config.video.mandatory || {};
                screenConfig.video.mandatory.chromeMediaSource = 'screen';
                getUserMedia(screenConfig, callback, error);
                break;
            case 'mozilla':
                Logger.debug(`Screen sharing in Firefox max fps: ${5}`);
                screenConfig = {};
                if (config.video !== undefined) {
                    screenConfig.video = {};
                    screenConfig.video.mediaSource = 'window' || 'screen';
                } else {
                    screenConfig = {
                        audio: config.audio,
                        video: { mediaSource: 'window' || 'screen' },
                    };
                }
                if (isCurrentVerLess(VcxEvent.constant.FIREFOX_VERSION_SCREEN_SHARE_WITHOUT_EXTN_SUPPORT)) {
                    getUserMedia(screenConfig, callback, error);
                } else {
                    //screenConfig.video = true;
                    screenConfig.video = { framerate: { max: config.fps} };
                    getDisplayMedia(screenConfig, callback, error);
                }
                break;
            case 'safari':
                if (!isCurrentVerLess(VcxEvent.constant.SAFARI_VERSION_SCREEN_SHARE_SUPPORT)) {
                    Logger.debug('Screen sharing  Safari ');
                    getDisplayMedia({ video: true }, callback, error);
                } else {
                    Logger.error(`Screen Sharing not supported for safari version: ${getBrowserVersion()}`);
                    EL.error(
                        'agent-event', customEvents.event_incompatible_browser,
                        { error: 'This safari version does not support ScreenSharing' },
                    );
                }
                break;

            case 'chrome-stable':
                Logger.debug('Screen sharing in Chrome');
                screenConfig = {};
                if (config.desktopStreamId) {
                    screenConfig.video = config.video || { mandatory: {} };
                    screenConfig.video.mandatory = screenConfig.video.mandatory || {};
                    screenConfig.video.mandatory.chromeMediaSource = 'desktop';
                    screenConfig.video.mandatory.chromeMediaSourceId = config.desktopStreamId;
                    screenConfig.video.mandatory.chromeMediaSourceId = config.desktopStreamId;
                    getUserMedia(screenConfig, callback, error);
                } else if (isCurrentVerLess(VcxEvent.constant.CHROME_VERSION_SCREEN_SHARE_WITHOUT_EXTN_SUPPORT)) {
                    let extensionId = 'apedaiecomcfkjdjbnkfcdafaikkdkeo';
                    if (config.extensionId) {
                        Logger.debug(`extensionId supplied, using ${config.extensionId}`);
                        extensionId = config.extensionId;
                    }
                    Logger.debug('Screen access on chrome stable, looking for extension');
                    try {
                        chrome.runtime.sendMessage(extensionId, { getStream: true }, (response) => {
                            if (response === undefined) {
                                Logger.error('Access to screen denied');
                                const theError = { code: 'Access to screen denied' };
                                error(theError);
                            } else {
                                const theId = response.streamId;
                                if (config.video.mandatory !== undefined) {
                                    screenConfig.video = config.video;
                                    screenConfig.video.mandatory.chromeMediaSource = 'desktop';
                                    screenConfig.video.mandatory.chromeMediaSourceId = theId;
                                } else {
                                    screenConfig = {
                                        video: {
                                            mandatory: {
                                                maxFrameRate: config.fps,
                                                chromeMediaSource: 'desktop',
                                                chromeMediaSourceId: theId,
                                            },
                                        },
                                    };
                                }
                                getUserMedia(screenConfig, callback, error);
                            }
                        });
                    } catch (e) {
                        Logger.debug('Screensharing plugin is not accessible ');
                        EL.error('agent-event', customEvents.event_incompatible_browser, { error: 'Screensharing plugin is not accessible' });
                        const theError = { code: 'no_plugin_present' };
                        error(theError);
                    }
                } else {
                    Logger.debug(`Screen sharing in Chrome without extension max Fps:: ${3}`);
                    screenConfig.video = { frameRate: { max: config.fps} };
                    console.log("RRRR Screen share details: " + JSON.stringify(screenConfig));
                    getDisplayMedia(screenConfig, callback, error);
                }
                break;

            default:
                Logger.error('This browser does not support ScreenSharing');
                EL.error('agent-event', customEvents.event_incompatible_browser, { error: 'This browser does not support ScreenSharing' });
        }
    };

    if (config.screen) {
        configureScreensharing();
    } else if (typeof module !== 'undefined' && module.exports) {
        Logger.error('Video/audio streams not supported in controller yet');
    } else {
        Logger.debug('Calling getUserMedia with config', JSON.stringify(config));
        getUserMedia(config, callback, error);
    }
};


const GetCanvasStream = (config, callback = () => { }, error = () => { }) => {
    let canvas = null; let
        stream = null;
    const browser = browserEngineCheck();
    let canvasFps;
    if (config.canvas) {
        if (browser === 'chrome-stable' || browser === 'mozilla' || browser === 'safari') {
            if (config.canvas.fps !== undefined && config.canvas.fps > 0) canvasFps = config.canvas.fps;
            else if (config.canvas.fps !== undefined) {
                Logger.error('Framerate is invalid is: ', config.canvas.fps);
                error(customErrors.error_1154);
                EL.error('agent-event', customEvents.event_incompatible_browser, { error: customErrors.error_1154 });
                return;
            }
            const { canvasId } = config.canvas;
            try {
                canvas = document.querySelector(`#${canvasId}`);
                if (canvas && (canvas instanceof HTMLMediaElement || canvas instanceof HTMLCanvasElement)) {
                    stream = canvas.captureStream((canvas instanceof HTMLCanvasElement ? canvasFps : undefined));
                    if (stream) callback(stream);
                    else {
                        // stream not found
                        Logger.error('captureStream() failed . canvasFps : ', canvasFps);
                        error(customErrors.error_1159);
                        EL.error('agent-event', customEvents.event_incompatible_browser, { error: customErrors.error_1159 });
                    }
                } else {
                    Logger.error('DOM Element does not exists/ not a Media Element. DomId is: ', canvasId);
                    EL.error('agent-event', customEvents.event_incompatible_browser, { error: customErrors.error_1157 });
                    error(customErrors.error_1157);
                }
            } catch (e) {
                Logger.error('DOM Element does not exists/ not a Media Element. DomId is: ', canvasId);
                error(customErrors.error_1157);
                EL.error(
                    'agent-event', customEvents.event_incompatible_browser,
                    { error: customErrors.error_1157, exception: (`Canvas chrome err: ${JSON.stringify(e)}`) },
                );
            }
        } else {
            Logger.error(' getCanvasStream() This browser does not support canvas');
            error(customErrors.error_1158);
            EL.error('agent-event', customEvents.event_incompatible_browser, { error: customErrors.error_1154 });
        }
    } else {
        Logger.error(' getCanvasStream() is called without canvas options');
        EL.error('agent-event', customEvents.event_incompatible_browser, { error: 'Canvas called without options' });
        error(customErrors.error_1155);
    }
};
const getAndroidVersion = () => {
  const ua = navigator.userAgent;
  if (ua.indexOf('Android') >= 0) {
    const androidversion = parseFloat(ua.slice(ua.indexOf('Android') + 8));
    return androidversion;
  }

    return false;
};
const Connection = {
    GetUserMedia,
buildPair,
browserEngineCheck,
getAndroidVersion,
mediaDeviceUpdate,
    getDeviceList,
    getBrowserVersion,
    GetCanvasStream,
    isCurrentVerLess,
};

export default Connection;



//////////////////
// WEBPACK FOOTER
// ./src/Pair.js
// module id = 8
// module chunks = 0